export const ROUTE_ACCESS_TYPE = {
    private: 'private',
    public: 'public',
    restricted: 'restricted',
};
